export default class EasternTownship {
    id: number;
    easternTownshipId: number;
    easternTownshipTypeId: number;
    unitName: string;
    tract: string;
    municipality: string;
    tsdNo: number;
    tsdName: string;
}



// WEBPACK FOOTER //
// ./src/models/projectSettings/subCode/section_types/EasternTownship.ts